import React from 'react';
import { NavLink } from 'react-router-dom';
import { motion } from 'framer-motion';
import { NavLinkItem } from './DesktopNav';

interface MobileNavProps {
  links: NavLinkItem[];
}

const MobileNav: React.FC<MobileNavProps> = ({ links }) => {
  return (
    <motion.div
      initial={{ y: 60, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.3, ease: 'easeOut' }}
      className="md:hidden fixed bottom-0 left-0 right-0 bg-white/90 backdrop-blur-md border-t border-gray-200 shadow-lg z-40"
    >
      <div className="flex justify-around items-center py-1">
        {links.map((link) => (
          <NavLink key={link.to} to={link.to} className="relative">
            {({ isActive }) => (
              <motion.div
                whileTap={{ scale: 0.9 }}
                className={`flex flex-col items-center py-2 px-3 rounded-lg transition-colors ${
                  isActive ? 'text-accent' : 'text-gray-500 hover:text-accent'
                }`}
              >
                <link.icon className="w-6 h-6" />
                <span className="text-[10px] font-bold">{link.label}</span>
                {isActive && (
                  <motion.div
                    layoutId="mobileIndicator"
                    className="absolute -top-0.5 left-1/2 -translate-x-1/2 w-1 h-1 rounded-full bg-accent"
                    transition={{ duration: 0.2 }}
                  />
                )}
              </motion.div>
            )}
          </NavLink>
        ))}
      </div>
    </motion.div>
  );
};

export default MobileNav;